import CbLabel from './src/label.vue';

CbLabel.install = function(Vue) {
  Vue.component(CbLabel.name, CbLabel);
};

export default CbLabel;
